// @flow

import {connect} from 'react-redux';
import React from 'react';
import {withRouter} from 'react-router-dom';
import './Button.css';

export type Props = {
  history: Object,
  disabled?: boolean,
  onClick?: ?Function,
  icon: string,
};

const Button = ({
  history,
  disabled = false,
  onClick,
  icon,
}: Props) => (
  <div className="Button">
    <button
      onClick={onClick || history.goBack}
      type="button"
      className="button secondary flat"
      disabled={!!disabled}>
      <i className={`fa fa-${icon}`}></i>
    </button>
  </div>
);

const none = () => ({});
export default withRouter(connect(none, none)(Button));



// WEBPACK FOOTER //
// ./src/components/Button/Button.js